import React from "react";
import {
    Heading,
    Text,
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHeaderItem,
    TableItem
} from "spectacle";

import ProfileThumbnail from '../components/ProfileThumbnail';
import { altolans } from '../content/collections/altolans/index';

const pictures = altolans.map((i) => i.profilePic);
const names = altolans.map((i) => i.name);
const descriptions = altolans.map((i) => i.specialization);

const WhoWeAre = () =>
    <div>
        <Heading size={4} textColor="secondary" caps>
            Who We Are
        </Heading>
        <Table padding={30}>
            <TableHeader>
                <TableRow>
                    {names.map((item, index) =>
                        <TableHeaderItem key={index}></TableHeaderItem>
                    )}
                </TableRow>
            </TableHeader>
            <TableBody>
                <TableRow>
                    {pictures.map((item, index) =>
                        <TableItem key={index} style={{ padding: '30px' }}>
                            <ProfileThumbnail image={item} />
                        </TableItem>
                    )}
                </TableRow>
                <TableRow>
                    {names.map((item, index) =>
                        <TableItem key={index} >
                            <h5 style={{margin: 0}}>{item}</h5>
                        </TableItem>
                    )}
                </TableRow>
                <TableRow>
                    {descriptions.map((item, index) =>
                        <TableItem key={index} >
                            <Text textSize={18} caps>{item}</Text>
                        </TableItem>
                    )}
                </TableRow>
            </TableBody>
        </Table>
    </div>;

export default WhoWeAre;


// WEBPACK FOOTER //
// ./src/slides/WhoWeAre.js